import { toUserMessage } from 'utils/apiErrorHelper';
import { api } from '../DefaultService';
import type { IJobProps } from './types';

const ENDPOINT = 'api/v1/jobs';

const formatApiError = (error: any): Error => {
  return new Error(toUserMessage(error));
};

export const getJobAsync = async (id: number): Promise<IJobProps> => {
  try {
    const response = await api.get(`${ENDPOINT}/${id}`);
    return response.data;
  } catch (error) {
    throw formatApiError(error);
  }
};

export const cancelJobAsync = async (id: number): Promise<void> => {
  try {
    await api.delete(`${ENDPOINT}/${id}`);
  } catch (error) {
    throw formatApiError(error);
  }
};
